import React from "react";
import ReactFlagsSelect from "react-flags-select";
import "./phoneinput.scss";

const PhoneInput = (props) => {
  return (
    <div
      className={props.disabled ? "select-box-disabled" : props.borderOutline}
    >
      <div className="tel-label">{props.label}</div>
      <div className="selected-option">
        <ReactFlagsSelect
          selected={props.selected}
          onSelect={props.onSelect}
          countries={props.countries}
          customLabels={props.customLabels}
          showSecondarySelectedLabel={true}
          showSelectedLabel={false}
          selectedSize={15}
          fullWidth={false}
          // searchable={true}
          placeholder=""
          disabled={props.disabled}
        />
        <div>
          <span className="pipe-symbol"></span>
        </div>
        <input
          type="tel"
          name="tel"
          value={props.value}
          onChange={props.onChange}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          disabled={props.disabled}
          maxLength={props.maxLength}
          aria-label={props.label}
        />
      </div>
    </div>
  );
};

export default PhoneInput;
